<template>
	<div class="container-wrap cs_page">
		<customer-top currentTab="notice"></customer-top>
		<div class="container-box">
			<h3 class="title mb_20">{{ $t('cs.notice') }}</h3>
			<accordion v-for="item in noticeList" :key="item.seq" class="notice cs">
				<accordion-item>
					<template v-slot:accordion-trigger>
						<p class="mb_0">{{ item.title }}</p>
						<div>
							<span class="mr_30 fc_gray2">{{
								$dayjs(item.regdate).format('YYYY.MM.DD')
							}}</span>
							<span class="accordion_trigger_icon"></span>
						</div>
					</template>
					<template v-slot:accordion-content>
						<div class="notice-accordion-content">
							<div v-html="item.content"></div>
						</div>
					</template>
				</accordion-item>
			</accordion>
			<pagination
				:totalCount="pageNavigation.total_count"
				:totalPage="pageNavigation.total_page"
				:curPage="pageNavigation.cur_page"
				:point="pageNavigation.point"
				:firstPage="pageNavigation.first_page"
				:lastPage="pageNavigation.last_page"
				@change="pageChangeHandler"
			></pagination>
		</div>
	</div>
</template>

<script>
import Accordion from '@/components/Layout/Accordion';
import AccordionItem from '@/components/Layout/AccordionItem';
import pagination from '@/components/Pagination';
import CustomerTop from '@/components/User/Cs/CustomerTop.vue';
import { fetchFaqList, fetchFaqTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';
export default {
	name: 'Notice',
	components: {
		Accordion,
		AccordionItem,
		pagination,
		CustomerTop,
	},
	data() {
		return {
			faqTypeList: [],
			noticeList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
		};
	},
	computed: {
		faqNotice() {
			return this.faqTypeList.find(item => {
				return item.name.toLowerCase() === 'notice';
			});
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			Promise.all([this.loadFaqTypeList()]).then(() => {
				this.loadNoticeList();
			});
		},
		async loadFaqTypeList() {
			const { data } = await fetchFaqTypes().catch(commonError);
			this.faqTypeList = data;
		},
		async loadNoticeList() {
			const params = {
				type_seq: this.faqNotice.seq,
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchFaqList(params).catch(
				commonError,
			);
			this.noticeList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadNoticeList();
		},
	},
};
</script>

<style scoped></style>
